import { Address } from '../../generic-models/views/Address';
import { CompanySummary } from '../../generic-models/views/CompanySummary';
import { User } from '../../generic-models/views/User';
import { ProductBlueprintDTO } from '../../product-models/DTOs/ProductBlueprintDTO';
import { CompanyDTO } from '../DTOs/CompanyDTO';

export class Company {
  id: string;
  name: string;
  footerText: string;
  logoUrl: string;
  slug: string;
  address: Address;
  companyUsers: User[];
  extraProductBlueprintIds: number[];
  email?: string | null;
  phoneNumber?: string | null;
  languages: string[];
  jsonData: any;

  constructor(
    id: string,
    name: string,
    footerText: string,
    logoUrl: string,
    slug: string,
    address: Address,
    users: User[],
    extraProductBlueprintIds: number[] = [],
    email?: string | null,
    phoneNumber?: string | null,
    languages: string[] = [],
    jsonData: string | null = null,
  ) {
    this.id = id;
    this.name = name;
    this.footerText = footerText;
    this.logoUrl = logoUrl;

    // if slug is not set is the same as id
    if (slug === '') {
      this.slug = id;
    } else {
      this.slug = slug;
    }

    this.address = address;
    this.companyUsers = users;
    this.extraProductBlueprintIds = extraProductBlueprintIds;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.languages = languages;

    if (jsonData) {
      this.jsonData = JSON.parse(jsonData);
    }
  }

  public static fromDTO(companyDTO: CompanyDTO) {
    return new Company(
      companyDTO.id.toString(),
      companyDTO.name,
      companyDTO.footerText,
      companyDTO.logoUrl,
      companyDTO.slug,
      companyDTO.address ? Address.fromDTO(companyDTO.address) : Address.getEmptyAddress(),
      companyDTO.companyUsers.map((user) => User.fromDTO(user)),
      companyDTO.extraProductBlueprintIds,
      companyDTO.email,
      companyDTO.phoneNumber,
      companyDTO.languages,
      companyDTO.jsonData,
    );
  }

  public static toCompanySummary(company: Company) {
    return new CompanySummary(
      company.id,
      company.name,
      company.footerText,
      company.logoUrl,
      company.slug,
      company.languages,
    );
  }
}
